import React, { useState } from 'react';
import {Box,
        Grid,
        Typography,
        Button,
        ButtonGroup,
        makeStyles 
} from '@material-ui/core';
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { useMediaQuery } from 'react-responsive';

import BurgerMenu from './BurgerMenuContent';
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';

const useStyles = makeStyles({
  background: {
    background: 'linear-gradient(180deg, #005479c7, transparent)',
    height: '85%',
  },
  buttonFontFamily: {
    fontFamily: 'Petit Formal Script',
    color: 'white',
    padding: '10px',
    textAlign: 'end',
  },
  buttonFontSize: {
    fontSize: '20px',
    color: 'white',
  },
  buttonFlex: {
    flexWrap: 'wrap',
    zIndex: 1,
  },
  link: {
    color: 'white',
    textDecoration: 'none',
  },
  navbarContainer: {
    position: 'fixed',
    zIndex: 5,
  },
  navbarWithBackgroud: {
    position: 'fixed',
    zIndex: 5,
    background: '#1f9fbe',
    animation: '$showUp 0.3s',
  },
  "@keyframes showUp": {
      '0%': {
        height: '0px',
    },
    '100%': {
        height: '72px',
    },
  },
})

function Navbar() {
    const [ showOnScroll, setShowOnScroll ] = useState(false);
    const [ appendMenu, setAppendMenu ] = useState(false);

    const classes = useStyles();
    const isSmallScreen = useMediaQuery({ query: '(max-width: 850px)' });

    useScrollPosition(({ prevPos, currPos }) => {
      (currPos.y < -200 && showOnScroll === false) && setShowOnScroll(true);
      (currPos.y > -300 && showOnScroll === true) && setShowOnScroll(false);
    })

    const handleAppend = () => setAppendMenu(!appendMenu);

    return(
        <Box className={classes.background} >

          { appendMenu && <BurgerMenu handleAppend={handleAppend} /> }

          <Grid 
            container 
            justify='space-between' 
            direction={isSmallScreen && 'row-reverse'}
            wrap={isSmallScreen && 'nowrap'}
            className={showOnScroll ? classes.navbarWithBackgroud : classes.navbarContainer}
          >

            <Grid item>
              <Typography className={classes.buttonFontFamily} variant={isSmallScreen ? 'h6' : 'h3'} >
                Dolní Věstonice
              </Typography>
            </Grid>

            {
              isSmallScreen ?
              <Button onClick={() => handleAppend()} >
                  <MenuIcon fontSize='large' style={{color: 'white'}} />
              </Button>
              :
              <ButtonGroup className={classes.buttonFlex} variant="text" size='large' aria-label="text primary button group">
                  <Button href='/' ><HomeIcon fontSize='large' style={{ color: 'white' }} /></Button>
                  <Button href='/pricelist' className={classes.buttonFontSize}>Ceník</Button>
                  <Button href='/calendar' className={classes.buttonFontSize}>Termíny</Button>
                  <Button href='/photogallery' className={classes.buttonFontSize}>Fotogalerie</Button>
                  <Button href='/contact' className={classes.buttonFontSize}>Kontakt</Button>
              </ButtonGroup>
            }
          </Grid>

        </Box>
    )
}

export default Navbar;